import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { Template } from "../../../commons/elements";
import eventType from "../../../prop-types/eventType";
import DataMessage from "../../../commons/data-message/components/data-message";
import { clearInfoMessage } from "../../../state/info-message/actions";

const propTypes = {
  types: PropTypes.arrayOf(eventType).isRequired
};

function InfoMessageContainer(props) {
  const { types } = props;
  const dispatch = useDispatch();
  const { message, tab } = useSelector((state) => state.infoMessage);
  const { logoImg } = useSelector((state) => state.client.clientBranding);

  useEffect(() => () => dispatch(clearInfoMessage()), []);

  const logoUrl = logoImg
    ? `https://dkzv15vwb753z.cloudfront.net/${logoImg}`
    : "";

  return (
    <Template fullHeight fullWidth tabName={tab} types={types}>
      <div className="d-flex justify-content-center align-items-center w-100 h-100 position-relative">
        <DataMessage dataMsg={message} clientLogo={logoUrl} />
      </div>
    </Template>
  );
}

InfoMessageContainer.propTypes = propTypes;

export default InfoMessageContainer;
